import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import NotificationService from "../../../services/notification-service";
import { siteUrl } from "../../../utils/siteUrl";
import "./notifications-menu.scss";

const NotificationsMenu = props => {
  const { mobile, activeNotificacion, setActiveNotificacion } = props

  const [listNotifications, setlistNotifications] = useState([])
  const [unreadAmount, setUnreadAmount] = useState(0)
  const [loadPetition, setloadPetition] = useState(false)

  const getAgeSegment = (age) => {
    if (age >= 9 && age <= 17) {
      return 'sara' //Sara
    } else if (age >= 18 && age <= 24) {
      return 'carolina' //carolina
    } else {
      return 'juliana' //juliana
    }
  }

  const calculateAge = () => {
    var today = new Date();
    var birthDate = new Date(JSON.parse(localStorage.getItem('USER_INFO')).birthdate);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  const token = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

  const config = {
    headers: {
      Authorization: token,
    },
  }

  useEffect(() => {
    const payload = {
      page: 0,
      size: 3,
      segment: getAgeSegment(calculateAge())
    }
    NotificationService.getListNotifications(payload, config)
      .then(res => {
        if (res.status === 200) {
          setlistNotifications(res.data.notification)
          setUnreadAmount(res.data.unreadAmount)
          setloadPetition(true)
        } else {
          // console.log(res)
        }
      })
      .catch(e => console.log(e))
  }, [])
  const homeLink = siteUrl

  const handleSeeNotifications = (notif, redirect) => {
    const token = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

    const config = {
      headers: {
        Authorization: token
      }
    }
    const payload = {
      notificationId: notif.notificationId,
      state: "VISTO",
    }
    NotificationService.updateNotifications(payload, config)
      .then(res => {
        window.location.href = redirect
      })
      .catch(e => console.log(e))
  }
  return (
    <>
      {!mobile ? (
        <>
          {activeNotificacion && (
            <div
              className="f-close-colapse f-close-notification"
              onClick={() => setActiveNotificacion(false)}
            ></div>
          )}
          <div className="f-MyNotifications">
            <div className="f-MyNotifications-HeaderNotifications">
              <div className="num-notifications">
                <div className="num">
                  <p>
                    {unreadAmount > 0 && unreadAmount < 100 && unreadAmount}
                    {unreadAmount > 99 && `99+`}
                    {unreadAmount === 0 && "0"}
                  </p>
                </div>
                <p className="notifications">NOTIFICACIONES</p>
              </div>
              <a href="/mis-notificaciones/#settings">
                <span className="icon-settings f-icon-settings" />
              </a>
            </div>
            {listNotifications.map(item => {
              return (
                <div
                  // href={homeLink + item.slug}
                  onClick={() => { handleSeeNotifications(item, homeLink + item.slug) }}
                  key={item.notificationId}
                  className={
                    "NewNotifications" +
                    (item.status ? " " : " f-new-notification-show")
                  }
                >
                  <div className="f-img-notifications-container">
                    <img
                      src={item.icon}
                      alt="Imagen de notificación"
                      className="f-img-notifications"
                    />
                  </div>

                  <div className="DescripNotifications">
                    <p>
                      {item.tag} {item.notificationDetail}
                    </p>
                    <p>
                      <small className="TimeNotifications">
                        {item.notificationDate.split("T")[0]}
                      </small>
                    </p>
                  </div>
                </div>
              )
            })}

            <div className="f-MyNotifications-FooterNotifications">
              {!loadPetition ? (
                <Loader
                  type="TailSpin"
                  color="#FF409B"
                  height={50}
                  width={50}
                />
              ) : (
                  <>
                    {listNotifications.length > 0 ? (
                      <a href="/mis-notificaciones">Ver todas</a>
                    ) : (
                        <p>Aún no tienes notificaciones.</p>
                      )}
                  </>
                )}
            </div>
          </div>
        </>
      ) : (
          <div className="f-notifications-class-container">
            {activeNotificacion && (
              <div
                className="f-close-colapse  f-close-notification"
                onClick={() => setActiveNotificacion(false)}
              ></div>
            )}
            <div className="f-NotificationMobile">
              <div className="f-MyNotifications-HeaderNotifications">
                <div className="num-notifications">
                  <div className="num">
                    <p>
                      {unreadAmount > 0 && unreadAmount < 100 && unreadAmount}
                      {unreadAmount > 99 && `99+`}
                      {unreadAmount === 0 && "0"}
                    </p>
                  </div>
                  <p className="notifications">NOTIFICACIONES</p>
                </div>
                <a href="/mis-notificaciones/#settings">
                  <span className="icon-settings f-icon-settings" />
                </a>
              </div>
              {listNotifications.slice(0, 2).map(item => {
                return (
                  <a
                    href={homeLink + item.slug}
                    onClick={() => {
                      handleSeeNotifications(item)
                    }}
                    key={item.notificationId}
                    className={
                      "NewNotificationsMobile" +
                      (!item.status ? " " : " f-new-notification-mobile-see")
                    }
                  >
                    <div className="f-img-mobile-container">
                      <img
                        src={item.icon}
                        alt="Imagen de notificación"
                        className="f-img-mobile-container-notification"
                      />
                    </div>
                    <div className="DescripNotifications">
                      <p>
                        <span className="f-nameNotifications">{item.tag} </span>
                        {item.notificationDetail}
                      </p>
                      <p>
                        <small className="TimeNotifications">
                          {item.notificationDate.split("T")[0]}
                        </small>
                      </p>
                    </div>
                  </a>
                )
              })}
              <div className="f-MyNotifications-FooterNotifications">
                {!loadPetition ? (
                  <Loader
                    type="TailSpin"
                    color="#FF409B"
                    height={50}
                    width={50}
                  />
                ) : (
                    <>
                      {listNotifications.length > 0 ? (
                        <a href="/mis-notificaciones">Ver todas</a>
                      ) : (
                          <p>Aún no tienes notificaciones.</p>
                        )}
                    </>
                  )}
              </div>
            </div>
          </div>
        )}
    </>
  )
}

export default NotificationsMenu
